import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import Popover from '@widget/popups/Popover';
import IconButton from '@widget/buttons/IconButton';
import ButtonComponent from '@widget/buttons/ButtonComponent';
import ButtonListContext from '@widget/buttons/ButtonListContext';
import MobileSheet from '@widget/popups/MobileSheet';
/**
 * @export
 * A self-contained help/info popover — renders a question-mark icon button that
 * opens a structured panel with a title and ordered sections of heading + body text.
 * Content is driven by a simple JSON array so no custom JSX or styles are needed.
 *
 * @example
 * ```tsx
 * <HelpPopover
 *   title="How Navigation Works"
 *   sections={[
 *     {
 *       heading: 'Master Links',
 *       body: 'The single source of truth for all navigation items.',
 *     },
 *     {
 *       heading: 'Navigation Profiles vs User Groups',
 *       body: 'A profile is a curated subset of master links for a user group.',
 *     },
 *   ]}
 * />
 * ```
 *
 * @category Overlays
 */
export const HelpPopover = ({ title, sections, position = 'bottom-right', icon = 'fal circle-question', variant = 'info', }) => {
    const content = (inSheet) => (_jsx("div", { className: `uxpcore_helppopover__content${inSheet ? ' uxpcore_helppopover__content--sheet' : ''}`, children: sections.map((section, index) => (_jsxs("div", { className: "uxpcore_helppopover__section", children: [_jsx("div", { className: "uxpcore_helppopover__heading", children: section.heading }), _jsx("div", { className: "uxpcore_helppopover__body", children: section.body })] }, index))) }));
    const listMode = useContext(ButtonListContext);
    const [open, setOpen] = useState(false);
    // In a list of actions (a phone ⋯ sheet): a row that opens the help in its own sheet,
    // over the list, so closing it returns to the list
    if (listMode && !listMode.icon) {
        return (_jsxs(_Fragment, { children: [_jsx(ButtonListContext.Provider, { value: {}, children: _jsx(ButtonComponent, { title: title, leftIcon: icon, variant: 'secondary', onClick: () => setOpen(true) }) }), _jsx(MobileSheet, { isOpen: open, onClose: () => setOpen(false), title: title, showClose: true, children: content(true) })] }));
    }
    return (_jsx(Popover, { title: title, content: () => content(), position: position, children: _jsx(IconButton, { icon: icon, variant: variant }) }));
};
